import { AuthProvider } from './global-provider';
import { XstateDevLogger } from './xstate/xstate-dev-logger';
import { RouterProvider } from './router';
import './app.scss';

function App() {
  return (
    <XstateDevLogger>
      <AuthProvider>
        <RouterProvider />
      </AuthProvider>
    </XstateDevLogger>
  );
}

export default App;
